import { render } from "./PromoCodePicnicToYogaView.vue?vue&type=template&id=82211dd6&scoped=true&ts=true"
import script from "./PromoCodePicnicToYogaView.vue?vue&type=script&lang=ts"
export * from "./PromoCodePicnicToYogaView.vue?vue&type=script&lang=ts"

import "./PromoCodePicnicToYogaView.vue?vue&type=style&index=0&id=82211dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82211dd6"]])

export default __exports__